import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Views from './views';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { THEME_CONFIG } from './configs/AppConfig';

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const hideResizeObserverOverlay = () => {
  const overlay = document.getElementById('webpack-dev-server-client-overlay');
  const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');

  if (overlay) overlay.style.display = 'none';
  if (overlayDiv) overlayDiv.style.display = 'none';
};

window.addEventListener('error', (event) => {
  if (
    event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    event.message === 'ResizeObserver loop limit exceeded'
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    hideResizeObserverOverlay();

    setTimeout(hideResizeObserverOverlay, 0);
    setTimeout(hideResizeObserverOverlay, 100);
  }
});

function App() {
  return (
    <div className='App'>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint='styles-insertion-point'
          >
            <Router>
              <Switch>
                <Route path='/' component={Views} />
              </Switch>
            </Router>
          </ThemeSwitcherProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;